import Vue from "vue";

export default {
  getDevices({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit("DEVICE_MUTATIONS", { key: "viewDevicesLoader", value: true });
      const searchQuery = state.searchQuery;
      const params = {
        page: state.page,
        perPage: state.perPage,
        ...(searchQuery && { search_query: searchQuery }),
        ...(state.filterValue != null &&
          state.filterValue != "" && { state: state.filterValue }),
      };

      Vue.$http
        .get("/attendance/devices", { params })
        .then(response => {
          commit("DEVICE_MUTATIONS", {
            key: "viewDevicesLoader",
            value: false,
          });
          commit("DEVICE_MUTATIONS", {
            key: "devices",
            value: response.data.results,
          });
          commit("DEVICE_MUTATIONS", {
            key: "devicesTotal",
            value: response.data.total,
          });
          resolve(response);
        })
        .catch(error => {
          commit("DEVICE_MUTATIONS", {
            key: "viewDevicesLoader",
            value: false,
          });
          reject(error);
        });
    });
  },

  handleSizeChange({ commit, dispatch }, perPage) {
    commit("DEVICE_MUTATIONS", { key: "perPage", value: perPage });
    commit("DEVICE_MUTATIONS", { key: "page", value: 1 });
    dispatch("getDevices");
  },

  handleCurrentChange({ commit, dispatch }, page) {
    commit("DEVICE_MUTATIONS", { key: "page", value: page });
    dispatch("getDevices");
  },

  getDeviceTypes({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/attendance/devices/types")
        .then(response => {
          commit("DEVICE_MUTATIONS", {
            key: "deviceTypes",
            value: response.data,
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  addDevice(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/attendance/devices", data)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },

  updateDevice(_, { id, data }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/attendance/devices/${id}`, data)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },

  getDevice(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/attendance/devices/${id}`)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },

  createDeviceCommands({ commit }, data) {
    commit("DEVICE_MUTATIONS", { key: "viewDevicesLoader", value: true });
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/attendance/devices/commands", data)
        .then(response => {
          commit("DEVICE_MUTATIONS", {
            key: "viewDevicesLoader",
            value: false,
          });
          resolve(response);
        })
        .catch(error => {
          commit("DEVICE_MUTATIONS", {
            key: "viewDevicesLoader",
            value: false,
          });
          reject(error);
        });
    });
  },

  getDeviceTransactions(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/attendance/devices/transactions", { params })
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },

  getTransactionLogById({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("DEVICE_MUTATIONS", {
        key: "viewDevicesLoader",
        value: true,
      });
      const routeId = state.idRoute;
      const params = {
        page: state.currentPageLog,
        perPage: state.perPageLog,
      };

      Vue.$http
        .get(`/attendance/devices/transactions/${routeId}/commands`, { params })
        .then(response => {
          commit("DEVICE_MUTATIONS", {
            key: "viewTransactionLog",
            value: response.data.results,
          });
          commit("DEVICE_MUTATIONS", {
            key: "viewTransactionLogTotal",
            value: response.data.total,
          });
          commit("DEVICE_MUTATIONS", {
            key: "viewDevicesLoader",
            value: false,
          });
          resolve(response);
        })
        .catch(error => {
          commit("DEVICE_MUTATIONS", {
            key: "viewDevicesLoader",
            value: false,
          });
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  getTransactionCommandById({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit("DEVICE_MUTATIONS", {
        key: "viewDevicesLoader",
        value: true,
      });
      Vue.$http
        .get(`/attendance/devices/transactions/${id}`)
        .then(response => {
          commit("DEVICE_MUTATIONS", {
            key: "viewTransactionCommand",
            value: response.data,
          });
          commit("DEVICE_MUTATIONS", {
            key: "viewDevicesLoader",
            value: false,
          });
          resolve(response);
        })
        .catch(error => {
          commit("DEVICE_MUTATIONS", {
            key: "viewDevicesLoader",
            value: false,
          });
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },

  handleSizeChangeForLog({ commit, dispatch, state }, perPage) {
    commit("DEVICE_MUTATIONS", { key: "perPageLog", value: perPage });
    commit("DEVICE_MUTATIONS", { key: "currentPageLog", value: 1 });
    dispatch("getTransactionLogById", {
      perPage: state.perPageLog,
      page: state.currentPageLog,
    });
  },

  handleCurrentChangeForLog({ commit, dispatch, state }, page) {
    commit("DEVICE_MUTATIONS", { key: "currentPageLog", value: page });
    dispatch("getTransactionLogById", {
      perPage: state.perPageLog,
      page: state.currentPageLog,
    });
  },

  getAllDeviceUsers({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("DEVICE_MUTATIONS", {
        key: "viewDevicesLoader",
        value: true,
      });
      const params = {
        page: state.pageUserMgt,
        per_page: state.perPageUserMgt,
        ...(state.searchQuery && { search_query: state.searchQuery }),
        ...(state.device_id !== "" && { device_id: state.device_id }),
      };

      Vue.$http
        .get(`/attendance/devices/users`, { params })
        .then(response => {
          commit("DEVICE_MUTATIONS", {
            key: "allDeviceUsers",
            value: response.data.results,
          });
          commit("DEVICE_MUTATIONS", {
            key: "allDeviceUsersTotal",
            value: response.data.total,
          });
          commit("DEVICE_MUTATIONS", {
            key: "viewDevicesLoader",
            value: false,
          });
          resolve(response);
        })
        .catch(error => {
          commit("DEVICE_MUTATIONS", {
            key: "viewDevicesLoader",
            value: false,
          });
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  handleSizeChangeUserMgt({ commit, dispatch, state }, perPage) {
    commit("DEVICE_MUTATIONS", { key: "perPageUserMgt", value: perPage });
    commit("DEVICE_MUTATIONS", { key: "pageUserMgt", value: 1 });
    dispatch("getAllDeviceUsers", {
      per_page: state.perPageUserMgt,
      page: state.pageUserMgt,
    });
  },

  handleCurrentChangeUserMgt({ commit, dispatch, state }, page) {
    commit("DEVICE_MUTATIONS", { key: "pageUserMgt", value: page });
    dispatch("getAllDeviceUsers", {
      per_page: state.perPageUserMgt,
      page: state.pageUserMgt,
    });
  },
  transferUsersToDevices(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/attendance/devices/commands/users-transfer", params)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  transferAllDevice(_, params) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/attendance/devices/commands/users/bulk-transfer", params)
        .then(response => resolve(response))
        .catch(error => reject(error));
    });
  },
  getAllDevices({ state, commit }) {
    return new Promise((resolve, reject) => {
      const searchQuery = state.searchQuery;
      const params = {
        ...(searchQuery && { search_query: searchQuery }),
      };
      Vue.$http
        .get("/attendance/devices", { params })
        .then(response => {
          commit("DEVICE_MUTATIONS", {
            key: "allDevices",
            value: response.data.results || response.data,
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
